








import { Component, Mixins } from "vue-property-decorator";
import {
  FormatMenu,
} from "../contents";
import { MainToolContainablePaneMixin } from "./mixins";

@Component({
  components: {
    FormatMenu,
  }
})
export default class LeftSidePane extends Mixins(MainToolContainablePaneMixin) {
}
